import { api } from '@ezugi/utils';

import { SELF_PING_URL } from './constants';

export const selfPing = () => api.get(SELF_PING_URL);
